import { ErrorsType } from 'interfaces';
import {
  useSigninCheckTfaMutation,
  useSigninResendMutation,
} from 'interfaces/graphql.types';
import { useAuth } from 'modules/auth/providers/AuthProvider';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { formatError, setSentryErrors } from 'utils/helpers/errorHandler';

export const useMultiFactorAuth = () => {
  const [errors, setErrors] = useState<ErrorsType>();
  const [CheckTfa, { loading }] = useSigninCheckTfaMutation();
  const [resend] = useSigninResendMutation();
  const { login } = useAuth();

  const router = useRouter();

  const resetErrors = (code: number) =>
    setErrors((errors) => errors?.filter((error) => error.code !== code));

  const onSubmit = async (values: { digitCodes?: string }) => {
    try {
      const result = await CheckTfa({
        variables: { data: { digitCodes: values.digitCodes || '' } },
      });
      if (
        result.data?.authCheckTfaCode.success &&
        typeof result.data.authCheckTfaCode.userId == 'string'
      ) {
        const userId = result.data.authCheckTfaCode.userId;
        await login({ userId }, router.query.to?.toString());
      } else {
        const errors = result.data?.authCheckTfaCode.errors;
        setErrors(errors);
        setSentryErrors(errors);
      }
    } catch (e) {
      setErrors([formatError(e)]);
      setSentryErrors(e);
    }
  };

  const resendRequest = async () => {
    try {
      const result = await resend();
      if (result.data?.authResendTfaCode.success) {
        setErrors([]);
      } else {
        const errors = result.data?.authResendTfaCode?.errors;
        setErrors(errors);
        setSentryErrors(errors);
      }
    } catch (e) {
      setErrors([formatError(e)]);
      setSentryErrors(e);
    }
  };

  return {
    loading,
    errors,
    onSubmit,
    resetErrors,
    resendRequest,
  };
};
